const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbulansBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "ambulans",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.73 55.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "border",
    d: "M79.33,4.69s7.31.59,8.71,1.53S99,17.93,99.57,18,113,24.75,115.29,28.16s.81,14.79-.74,15.72S96,51.56,92,51.28s-2.28,2.2-5.76,3.13-10.58,1.43-12.61-.84-11.9-6.34-11.9-6.34-16.4-4.5-18.28-4.16-5.45,1.58-7.78.65-6-6.2-6-6.2-3.48-3.76-5.31-3.43-6.9,4.7-9.71,4.22-12.31-.92-13.29-4,.67-6.18,0-9.44-2.11-6.54,0-10.64S6.22,6.5,8.41,7.14s4.29,4.42,5.25,2.22,3-4.1,5-3.61S23,15.86,25.07,15.23,26.82,12,27.92,9.36,39.74,6,39.74,6s15.16-1,15.78-2.46S56,.66,59.38.35,78.24.41,79.11,1.93A3,3,0,0,1,79.33,4.69Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulansBorder);
export default __webpack_public_path__ + "static/media/ambulans-border.c506dc4bbed53e54bdbc100ac07bf6d5.svg";
export { ForwardRef as ReactComponent };